import { Box, Button, Text } from '@chakra-ui/react';

import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';

import { getImages, getBlocks } from 'utils/game/gameService';
import { useParams } from 'react-router-dom';
import { MdVerified } from 'react-icons/md';

const CompletionScreen: React.FC<{
  handleChange: (e: any) => void;
  formData: any;
  inputRef: any;
}> = ({ handleChange, formData, inputRef }) => {
  const [img, setImg] = useState<any[]>([]);
  const [isOpenBadge, setIsOpenBadge] = useState<any>(false);
  const [blocks, setBlocks] = useState<any[]>([]);
  const [backgroundIndex, setBackgroundIndex] = useState<number>();
  const [chosen, setChosen] = useState<any>('A');
  const options = [
    { value: 'A', name: 'End Of Game' },
    { value: 'B', name: 'Each Question' },
  ];
  const musicOptions = [
    { value: 1, label: 'Jazz' },
    { value: 1, label: 'Melodic Harmony' },
    { value: 1, label: 'Rhythmic Serenity' },
    { value: 1, label: 'Echoes of Euphoria' },
    { value: 1, label: 'Sonic Reverie' },
    { value: 1, label: 'Tranquil Melodies' },
    { value: 1, label: 'Harmonic Bliss' },
    { value: 1, label: 'Mystical Cadence' },
    { value: 1, label: 'Celestial Rhythms' },
    { value: 1, label: 'Enchanted Sonata' },
    { value: 1, label: 'Symphony of Dreams' },
  ];
  const { id } = useParams();
  const userDetails = JSON.parse(localStorage.getItem('user'));

  const fetchData = async () => {
    const ctId = userDetails?.data?.id.toString();

    const result = await getImages(4, ctId);
    if (result?.status !== 'Success') {
      return alert('getbackruond error:' + result?.message);
    }
    setImg(result?.data);

    const block = await getBlocks(id);
    if (block?.status !== 'Success')
      return alert('getbackruond error:' + block?.message);
    setBlocks(block?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card mb={{ base: '0px', xl: '20px', sm: '20px' }}>
      <Text fontSize={20} fontWeight={800} mb={'20px'}>
        Launch
      </Text>
      <Box
        w={'100%'}
        h={'300px'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box as={MdVerified} color={'green.300'} h={'250px'} width={'250px'} />
      </Box>
      <Box w={'100%'} display={'flex'} justifyContent={'flex-end'}>
        <Button bg="#3311db" _hover={{ bg: '#3311db' }} color="#fff" w="80px">
          Preview
        </Button>
      </Box>
    </Card>
  );
};
export default CompletionScreen;
